
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'pinLabel': '置顶',
	'find_label': '查找',
	'findCancelLabel': '取消',
	'sourcePaneLabel': '所选源',
	'sourcePaneContentLabel': '选择源',
	'addDataDashboardCoachMarkContents': '将数据从数据面板拖放到仪表板上。',
	'addDataStoryCoachMarkContents': '将数据从数据面板拖放到案例上。',
	'addDataCoachMarkTitle': '添加数据',
	'selectSourcesText': '选择并添加数据源以构建 %{app}。',
	'selectSourcesLabel': '选择源',
	'errorSourcesTitle': '未能装入数据树',
	'errorLoadingDataSources': '装入数据集列表时出错',
	'errorLoadingDataTree': '装入树时发生错误',
	'dataSetPaneLastUpdated': '上次更新时间：%{date}',
	'dataSourcePaneDateUnknown': '未知',
	'moreTitle': '更多',
	'backLabel': '返回',
	'addDataSourceDialogTitle': '添加数据源',
	'addDataSourceDialogButtonLabel': '添加',
	'dlg_use': '使用',
	'dlg_RelinkDataSourceTitle': '将数据集“%{dataSourceName}”替换为...',
	'propertiesDialogTitle': '属性',
	'missingDataSetData': '此数据集的数据不可用。请刷新此数据集，或联系管理员以获取对该源的访问权。',
	'errorLoadingSource': '未装入“%{sourceName}”的元数据。请联系您的管理员以获取详细信息。',
	'errorMessageTitle': '错误',
	'calculation_navigation_in_use': '删除计算或导航路径会使引用所删除项的所有可视化失效。确定要删除吗？',
	'delete_confirm': '确认删除',
	'previewUnavailable': '数据托盘和全局过滤器不可用于此数据包类型。',
	'contextualGridTabName': '可视化数据',
	'DATA_TRAY_no_data_text': '“您的数据将显示在此处。”',
	'contextualGridMenuLabel': '可视化数据菜单',
	'contextualGridExport': '导出',
	'nullValueText': '空值',
	'forecastDetailsTabName': '正在预测统计详细信息',
	'forecastDetailsModelLabel': '模型',
	'forecastDetailsQualityMetricLabel': '准确性度量',
	'forecastDetailsSmoothingCoefLabel': '参数',
	'forecastDetailsDiagnostics': '诊断',
	'forecastDetailsForecastLabel': '预测',
	'forecastDetailsStatusLabel': '状态',
	'forecastDetailsAccuracyPercentLabel': '准确性 %',
	'forecastDetailsTrendLabel': '趋势',
	'forecastDetailsSeasonLabel': '季节性',
	'forecastDetailsSeasonalPeriodLabel': '季节性周期',
	'forecastDetailsAlphaLabel': 'α',
	'forecastDetailsBetaLabel': 'β',
	'forecastDetailsGammaLabel': 'γ',
	'forecastDetailsPhiLabel': 'φ',
	'forecastDetailsMissingCount': '缺少计数',
	'forecastDetailsSeriesLengthLabel': '序列长度',
	'forecastDetailsIgnoredPeriods': '忽略的时间段数',
	'forecastDetailsTrendStrength': '趋势强度',
	'forecastDetailsSeasonalityStrength': '季节性强度',
	'forecastDetailsTimeDeltaUnit': '日期/时间间隔',
	'forecastDetailsNotes': '注释'
});
